/**
 * Parses one offer url, removing any unnecessary query parameters.
 */
const getOfferUrl = (offerUrl) => (
  (offerUrl ?? "").split("?")?.[0]
);

export default getOfferUrl;
